export const currencyFormatter = ({
	locale,
	currencySymbol,
	currencyCode,
	currencyLocale,
}) => {
	const formatter = new Intl.NumberFormat(currencyLocale, {
		style: 'decimal', // TODO: Change this to currency if we change euro to correct format of 5,00 € rather than €5,00.
		currency: currencyCode,
		minimumFractionDigits: locale === 'TUK' ? 2 : 0,
		maximumFractionDigits: 2,
	});

	return {
		format: (number) => `${currencySymbol}${formatter.format(number)}`,
	};
};

export const savingsPercentage = (was, save) => {
	return Math.floor((save / was) * 100) + '%';
};
